module.exports = __webpack_public_path__ + "r-v3/img/ml_61_00_over.b96e4e9f.jpg";